/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import ButtonShell from './ButtonShell'

const StyledButton = styled.div`
  background-color: ${props => props.theme.color.face.main};
  display: inline-block;
  border-radius: 25.5px;
  
  & > a, & > button {
    color: ${props => props.theme.color.text.secondary};
    padding: 13.5px 35px;
    width: 100%;
    height: 100%;
    display: block;
    font-family: ${props => props.theme.font.family.secondary};
    font-weight: ${props => props.theme.font.weight.xl};

    &:hover {
      color: ${props => props.theme.color.text.secondary};
      text-decoration: none;
    }
  }
`

const ButtonContrast = ({ newPage, isAnchor, isCustom, to, children, className }) => (
  <StyledButton className={className}>
    {isCustom ? children : (
      <ButtonShell newPage={newPage} to={to} isAnchor={isAnchor}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonContrast